<app-basemap class="font-awesome" />

<app-legend />

<app-report-spatial-selection />

<div class="top-left-container flex flex-col mt-6 items-start"> </div>

<div class="bottom-left-container" [style.margin-left.px]="leftMargin()">
  <div class="justify-center flex">
    <div
      [matTooltip]="'Module.Layer.DeactivatedInfo' | transloco"
      matTooltipPosition="right"
      [matTooltipDisabled]="!layerService.isDeactivated()"
    >
      <button
        mat-icon-button
        (click)="openLayers()"
        [ngClass]="{ 'layers-button': true, active: layerService.hasActiveLayers() }"
        data-testid="layers-button"
        [matTooltip]="'Title.ThematicInformation.Header.LayerInformation' | transloco"
        [disabled]="layerService.isDeactivated() || permissionService.isBlockedByQuota()"
      >
        <mat-icon svgIcon="icn-layers" />
      </button>
    </div>
  </div>
  <div class="mt-1 justify-center flex">
    <app-spatial-analysis-task-bar [modes]="spatialAnalyisModes()" (taskIconClicked)="taskIconClicked($event)" />
  </div>
  <div class="mt-1 justify-center flex">
    @if (layerService.isLayerActivated()) {
      <button
        mat-icon-button
        (click)="toggleLegend()"
        [ngClass]="{ 'layers-button': true, active: layerService.showLegend() }"
        data-testid="layers-legend-button"
      >
        <mat-icon svgIcon="icn-map-info" />
      </button>
    }
  </div>
  <div class="mt-1 justify-center">
    @if (BaseMapRight()) {
      <app-basemap-selector />
    }
  </div>
</div>

<div class="bottom-map-container flex flex-row justify-center items-center">
  <app-task-info />
</div>

<app-popup />

<router-outlet />
